// extracted by mini-css-extract-plugin
module.exports = {"block":"block-4e0937","logo":"logo-4e0937","logo_small":"logo_small-4e0937","logo_medium":"logo_medium-4e0937","logo_main":"logo_main-4e0937"};